import styled from "styled-components";

export const PreviewStyles = styled.div`
  margin-top: 85px;
  background: var(--glz-color-primary-tone-3);
  height: fit-content;
  white-space: none;
  padding: 0 10px 60px;
  @media (max-width: 900px) {
    padding: 0 10px 32px;
  }
`;

export const PreviewIcon = styled.img`
  display: inline-block;
  width: 130px;
  height: 55px;
`;

export const PreviewLogo = styled.div`
  align-items: center;
  max-width: 300px;
  margin: 0 auto 60px;
`;

export const HeaderStyles = styled.div`
  width: 100%;
  max-width: 1140px;
  margin: 0 auto 0px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 56px 0 34px 0;
  .header-image {
    @media (max-width: 900px) {
      height: 42px;
      width: 100px;
    }
  }
  .header-phone {
    padding-left: 54px;
    @media (max-width: 900px) {
      text-align: center;
      padding: 24px 0 0;
      font-size: 12px;
    }
  }
  .phone {
    font-size: 20px;
    padding-top: 10px;
    :hover {
      color: var(--glz-color-neutral-tone-5-rgb);
      text-decoration: none;
    }
    @media (max-width: 900px) {
      font-size: 14px;
    }
  }
  @media (max-width: 900px) {
    max-width: 400px;
    flex-direction: column;
  }
`;

export const PhonePreview = styled.img`
  display: inline-block;
  width: 24px;
  height: 24px;
  @media (max-width: 900px) {
    max-width: 400px;
    padding: 32px 10px;
  }
`;

export const BodyStyles = styled.div`
  width: 100%;
  max-width: 1140px;
  margin: 0 auto 0px;
  .footer-text {
    color: var(--glz-color-neutral-tone-4);
    font-size: 12px;
    max-width: 1050px;
    @media (max-width: 900px) {
      max-width: 400px;
      color: var(--glz-color-neutral-tone-3);
      font-size: 10px;
    }
  }
  .footer-text-bottom {
    max-width: 1140px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: var(--glz-color-neutral-tone-5);
    @media (max-width: 900px) {
      max-width: 400px;
      font-size: 10px;
      flex-direction: column;
      align-items: start;
      padding-bottom: 16px;
    }
  }
  .links {
    text-align: center;
    width: content;
    color: var(--glz-color-neutral-tone-5);
    @media (max-width: 900px) {
      font-size: 10px;
      padding-top: 16px;
    }
  }
  .footer {
    display: flex;
    padding-bottom: 36px;
    text-align: center;
    @media (max-width: 900px) {
      flex-direction: column;
    }
  }
  .img-footer {
    padding-right: 10px;
    @media (max-width: 900px) {
      transform: rotate(90deg);
    }
  }
  .footer-items {
    padding-right: 26px;
    display: flex;
    font-size: 12px;
    align-items: center;
    @media (max-width: 900px) {
      flex-direction: column;
      padding: 0 0 10px;
    }
  }
  @media (max-width: 900px) {
    max-width: 400px;
  }
`;

export const CalculateLogo = styled.img`
  display: inline-block;
  width: 488px;
  height: 532px;
`;

export const TitleForStyle = styled.div`
  color: var(--glz-color-neutral-tone-4);
  font-size: 14px;
`;

export const NameCompanyStyle = styled.div`
  font-size: 40px;
  font-weight: 700;
`;

export const DescriptionStyle = styled.div`
  font-size: 22px;
  line-height: 33px;
  font-weight: 400;
`;

export const TermsStyle = styled.img`
  width: 75px;
  height: 75px;
`;

export const TermsBlockStyle = styled.div`
  display: flex;
  border-bottom: 1px solid var(--glz-color-neutral-tone-1);
  padding-bottom: 90px;
`;

export const TermStyle = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const TitleTerms = styled.div`
  color: var(--glz-color-neutral-tone-5);
  font-size: 18px;
`;

export const VerificationCompanyStyle = styled.div``;

export const VerifationLogoStyle = styled.img`
  width: 501px;
  height: 532px;
`;
